import React, { useState } from "react";
import { Box } from "@mui/material";
import Header from "./components/Header/Header.js";
import MainContent from "./components/MainContent/MainContent.js";
import { SearchProvider } from "./context/searchContext.js";

function App() {
    const [filterOpen, setFilterOpen] = useState(false);
    return (
        <SearchProvider>
            <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
                <Header onOpenFilter={() => setFilterOpen(true)} />
                <Box sx={{ flex: 1, overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
                    <MainContent
                        filterOpen={filterOpen}
                        onOpenFilter={() => setFilterOpen(true)}
                        onFilterClose={() => setFilterOpen(false)}
                    />
                </Box>
            </Box>
        </SearchProvider>
    );
}

export default App;
